import styled from "styled-components";

export const ActiveProjectsTabViewWrapper = styled.div``